import {
  regName,
  regComName,
  regMobile,
  regRank,
  regAddress,
  regEmail,
  regFaxTel,
  regZipCode
} from '@/utils/regs.js'
// 校验姓名
export const validatorName = (val, { required }) => {
  if (required) {
    if (!val) {
      return false
    }
    return regName.test(val)
  }
  return true
}
// 校验公司名
export const validatorComName = (val, rule) => {
  if (rule.required) {
    if (!val) {
      return false
    }
    return regComName.test(val)
  }
  return true
}
// 校验性别
export const validatorGender = (val, rule) => {
  if (rule.required) {
    if (!val) {
      return false
    }
    return true
  }
  return true
}
// 校验职务
export const validatorRank = (val, { required }) => {
  if (required) {
    if (!val) {
      return false
    }
    return regRank.test(val)
  }
  return true
}
// 部门
export const validateDept = (val, { required }) => {
  if (required) {
    if (!val) {
      return false
    }
    const reg = /^[/.,\sa-zA-Z\u4e00-\u9fa5\uF900-\uFA2D]{2,50}$/
    return reg.test(val)
  }
  return true
}
// 校验手机号
export const validatorMobile = (val, { required }) => {
  if (required) {
    if (!val) {
      return false
    }
    return regMobile.test(val)
  }
  return true
}
// 校验邮箱
export const validatorEmail = (val, { required }) => {
  if (required) {
    if (val) {
      return regEmail.test(val)
    }
    return false
  }
  return true
}
// 校验地址
export const validatorAddress = (val, { required }) => {
  if (required) {
    if (val) {
      return regAddress.test(val)
    }
    return true
  }
  return true
}
// 校验网址
export const validatorUrl = (val, { required }) => {
  if (required) {
    if (!val) {
      return false
    }
    const reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/){0,1}(([A-Za-z0-9-~]+)\.)+(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~/])+$/
    return reg.test(val)
  }
  return true
}
// 校验传真
export const validatorFax = (val, { required }) => {
  if (required) {
    if (val) {
      return regFaxTel.test(val)
    }
    return false
  }
  return true
}

// 校验邮编
export const validateZipCode = (val, { required }) => {
  if (required) {
    if (val) {
      return regZipCode.test(val)
    }
    return false
  }
  return true
}
